import React, { useEffect, useState } from 'react'
import { getCollectionList, getmarketItemOfCollection } from '../../../hooks/Collectionhook';
import { GweiToether, getDataFromURI } from '../../../hooks/Tokenhook';
import { contractAddress } from '../../../config/BackendUrl';
import { loadAllNFTs } from '../../../assets/Data/NFT';
import { Link } from 'react-router-dom';
import { avatar } from '../../../assets/img';
import itemLogo from "../../../assets/img/items/item_1.png";

const NFTsForFNFT = () => {
  const [nfts, setNfts] = useState([]);

  const walletAddress = localStorage.getItem("WalletAddress");

  useEffect(() => {
    const fetchData = async () => {
      const allNFTsData = await loadAllNFTs(contractAddress);
      if (allNFTsData.status === 200) {
        const NFTs = allNFTsData.data;
        setNfts(NFTs.filter(data => data.creator === walletAddress))
        console.log("AllNFT", NFTs);
      }
       };
    fetchData();
}, [])

  const handleError = (event) => {
    event.target.src = avatar;
  };

  const handleError1 = (event) => {
    event.target.src = itemLogo;
  };

  console.log("NFTS", nfts);

  return (
    <div className='container'>
      <h2 className='my-4'>
        NFTs
      </h2>
      <div className="row">
        {nfts.map((val, i) => (
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6" key={i}>
            <Link to={`/deployfnft/${contractAddress}/${val._id}`}>
              <div className="card__item four">
                <div className="card_body space-y-10">
                  <div className="creators space-x-10">
                    <div className="avatars space-x-3">
                      <Link to={`/profile/${val.creator}`}>
                        <img
                          src={val.creatorprofilePicture}
                          alt=""
                          className="avatar avatar-sm"
                          onError={handleError}
                        />
                      </Link>
                      <Link to={`/profile/${val.creator}`}>
                        <p className="avatars_name txt_xs">
                          {val.creatorName}
                        </p>
                      </Link>
                    </div>
                  </div>
                  <div className="card_head">
                    <img src={val.image} alt="nft image" onError={handleError1} />
                    <div className="likes space-x-3">
                      <i className="ri-heart-3-line" />
                      <span className="txt_sm">{val.totalLikes}</span>
                    </div>
                  </div>

                  <div className="card_footer d-block space-y-10">
                    <div
                      className="d-flex align-items-center space-x-10 justify-content-between">
                      <div
                        className="d-flex align-items-center space-x-5">
                        <h6 className="card_title">
                          <div className="color_black" style={{ textTransform: "capitalize" }}>
                            {val.title}
                          </div>
                        </h6>
                      </div>
                      <div className="txt_sm">
                        Price:{" "}
                        <span className="color_green txt_sm">
                          {GweiToether(val.price)} ETH
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NFTsForFNFT
